import { render, staticRenderFns } from "./OpportunityForm.vue?vue&type=template&id=175df640"
import script from "./OpportunityForm.vue?vue&type=script&lang=js"
export * from "./OpportunityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175df640')) {
      api.createRecord('175df640', component.options)
    } else {
      api.reload('175df640', component.options)
    }
    module.hot.accept("./OpportunityForm.vue?vue&type=template&id=175df640", function () {
      api.rerender('175df640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/OpportunityForm.vue"
export default component.exports